module.exports = __webpack_public_path__ + "img/ENJ.a46ce5b8.svg";